const MAX_RETRY = 3;
export const retry = async (
/**
 * A function returning a fetch handler.
 */
handler, 
/**
 * Maximum number of times the request should be attempted.
 */
maxRetry = MAX_RETRY) => {
    if (maxRetry <= 1) {
        return (await handler());
    }
    try {
        return (await handler());
    }
    catch (error) {
        const remainingAttempt = maxRetry - 1;
        console.warn(`\`retry\` attempts a new operation (remaining attempt(s): \`${remainingAttempt}\`, cause: \`${error}\`)`, error);
        return await retry(handler, remainingAttempt);
    }
};
export const fetchRetry = (
/**
 * A function returning a fetch handler.
 */
fetchHandler, 
/**
 * Maximum number of times the request should be attempted.
 */
maxRetry = MAX_RETRY) => {
    return retry(async () => {
        const res = await fetchHandler();
        if (!res.ok) {
            throw new Error(`\`fetchRetry\` retries \`${res.url}\` call (cause: \`${res.status}\` HTTP code${res.statusText ? ` with the status message \`${res.statusText}\`` : ""})`);
        }
        return res;
    }, maxRetry);
};
